<script lang="ts">
	import ChromosomeHero from "@components/ChromosomeHero.svelte";
	import PageHero from "@components/PageHero.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonSize, ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import { Chromosome } from "@core/schema/Chromosome.js";
	import { getProductPath } from "@core/schema/paths/getProductPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { SubcategoryProps } from "./SubcategoryProps.js";

	const { products, subcategory }: SubcategoryProps = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<Layout>
	<PageHero headline={subcategory.name[tenant.locale]} />

	<div class="flex gap-8 pt-20 pb-24">
		<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex-wrap gap-3 w-full">
			{#each products as product (product.id)}
				<div
					class="p-4 border-2 border-white hover:border-lightblue transition-all duration-300 bg-white flex flex-col justify-between rounded-xl gap-2 max-w-80 max-h-56"
				>
					<div class="flex flex-col gap-2">
						<span class="text-md font-medium min-h-10">{product.name[tenant.locale]}</span>
						<div class="flex gap-2 items-start">
							{#if product.locations.some((location) => Object.values(Chromosome).includes(location.chromosome))}
								<span class="text-xs leading-6">Sondy:</span>
							{/if}
							<div class="flex gap-0.5 flex-wrap">
								{#each Object.values(Chromosome).filter( (chromosome) => product.locations.some((location) => location.chromosome === chromosome), ) as chromosome (chromosome)}
									<span class="px-2.5 text-xs py-1 leading-tight rounded-full bg-lightblue">{chromosome}</span>
								{/each}
							</div>
						</div>
					</div>
					<Link
						class="self-end"
						variant={ButtonVariant.Outline}
						size={ButtonSize.Sm}
						href={getProductPath(tenant, product)}>Detail</Link
					>
				</div>
			{:else}
				<p>Žádné produkty.</p>
			{/each}
		</div>
	</div>
	<ChromosomeHero />
</Layout>
